export default {
  name: "ProductsGrid",

  data: {
    filterActive: false,
    filterValue: null,
    searchValue: ""
  },

  computed: {
    categoryDescription() {
      if (this.filterValue) {
        const cat = this.categories.filter(cat => cat.id === this.filterValue)[0];
        if (cat) {
          return cat.description;
        }
      }
      return null;
    },

    filterLabel() {
      if (this.filterValue === null) {
        return "Filtra";
      } else {
        return this.categories.filter(cat => cat.id === this.filterValue)[0].name;
      }
    },

    productsFiltered() {
      let products = this.products;

      if (this.searchValue.trim().length > 3) {
        const nameRegex = new RegExp(`${this.searchValue.trim()}`, 'i');
        products = products.filter(product => !!product.name.match(nameRegex));
      }

      if (typeof this.filterValue === "number") {
        products = products.filter(product => product.categories.map(cat => cat.id).includes(this.filterValue));
      }

      return products;
    }
  },

  methods: {
    selectFilter(id) {
      this.filterValue = (this.filterValue === id) ? null : id;
    }
  }
}